import PrivateRoute, { Router } from '@Components/app-layout/PrivateRoute';

import EmailTemplatesGrid from '../components/Grid';
import { EmailTemplateProvider } from '../store';

import EmailTemplateFormLayout from './Form';

export default function EmailTemplatesGridLayout() {
  return <EmailTemplateProvider>
    <EmailTemplatesGrid />
    <Router>
      <PrivateRoute path={["/settings/email-templates/add/:typeTemplate", "/settings/email-templates/:id"]} component={EmailTemplateFormLayout} />
    </Router>
  </EmailTemplateProvider>;
}
